import React from "react";
import "./Button.scss";
const Button = ({ children, onClick, disabled }) => {
  return (
    <button
      type="button"
      className="button"
      disabled={disabled}
      onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
